export const GENRE = [
  {
    name: "Disco-Funk",
    id: 608434380,
    link:"#Disco-Funk"
  },
  {
    name: "House",
    id: 608433279,
    link:"#House"
  },
  {
    name: "Deep House",
    id: 608435115,
    link:"#Deep House"
  },
  {
    name: "Techno",
    id: 609591984,
    link:"#Techno"
  },
  {
    name: "Cosmix",
    id: 610507359,
    link:"#Cosmix"
  },
  {
    name: "Events",
    id: 0,
    link:"#Events"
  },
  {
    name: "About",
    id: 1,
    link:"#About"
  },
  
]




// WEBPACK FOOTER //
// ./src/constants/Genre.js